
export default {
	GET_PENDING_PARTNER_BOOKINGS(state, data) {
		state.pending_partner_bookings = data.data
	},
	GET_PENDING_GROUP_BOOKINGS(state, data) {
		state.pending_group_bookings = data.data
	},
	GET_BOOKINGS(state, data) {
		state.bookings = data.data
	},
	GET_BOOKINGS_STREAM_DATA(state, data) {
		state.all_bookings = data.data
	},
	GET_ALL_BOOKINGS(state, data) {
		state.all_bookings = data.data
	},
	GET_ALL_BOOKINGS_REPORT(state, data) {
		state.all_bookings_report = data.data
	},

	GET_MORE_BOOKINGS(state, data) {
		var bookings = data.data
		for (var i = 0; i < bookings.length; i++) {
			state.all_bookings.push(bookings[i])
		}
	},
	GET_BOOKING(state, data) {
		state.booking = data.data[0]
	},
	GET_BOOKING_VIEW_DETAIL(state, data) {
		state.booking_detail = data.data[0]
	},
	GET_BOOKING_VIEW_MORE_DETAIL(state, data) {
		state.booking_more_detail = data.data[0]
	},
	GET_BOOKING_CHECKIN(state, data) {
		state.booking_checkin = data.data[0]
	},
	GET_BOOKING_PAYMENT(state, data) {
		state.booking_payment = data.data[0]
	},
	GET_SINGLE_BOOKING_TOTAL_COST(state, data) {
		state.booking_cost = data.data
	},
	GET_BOOKING_TICKETS(state, data) {
		state.booking_tickets = data.data
	},
	GET_BATCHFILE_DATA(state, data) {
		state.batchfile_data = data.data
	},
	GET_BOOKING_PASSES(state, data) {
		state.booking_passes = data.data
	},
	GET_DELETED_BOOKINGS(state, data) {
		state.deleted_bookings = data.data
	},
	GET_CONFIRMED_BOOKINGS(state, data) {
		state.confirmed_bookings = data.data
	},
	GET_UN_CONFIRMED_BOOKINGS(state, data) {
		state.un_confirmed_bookings = data.data
	},
	GATE_ENTRY_REPORT(state, data) {
		state.gate_entry_report = data.data
	},
	DAILY_REPORT(state, data) {
		state.daily_report = data.data
	},
	BOOKINGS_INSPECTION_REPORT(state, data) {
		state.bookings_inspection_report = data.data
	},
	GET_CHECKED_IN_BOOKINGS(state, data) {
		state.checked_in_bookings = data.data
	},
	GET_CHECKED_OUT_BOOKINGS(state, data) {
		state.checked_out_bookings = data.data
	},
	GET_AVAILABILITY(state, data) {
		state.activity_slots = data.data[0].available_slots
	},
	REMOVE_AVAILABILITY(state) {
		state.activity_slots = 0
	},
	GET_CHECKING_IN_TODAY(state, data) {
		state.checking_in_today = data.data
	},
	GET_CHECKING_OUT_TODAY(state, data) {
		state.checking_out_today = data.data
  },
  GET_OVERSTAYS_THIS_MONTH(state, data) {
    state.overstays_this_month = data.data
  },
	GET_ALL_PARTNER_BOOKINGS(state, data) {
		state.all_partner_bookings = data.data
	},
	GET_PARTNER_BOOKINGS(state, data) {
		state.partner_bookings = data.data
	},
	GET_MORE_PARTNER_BOOKINGS(state, data) {
		var bookings = data.data
		for (var i = 0; i < bookings.length; i++) {
			state.partner_bookings.push(bookings[i])
		}
	},
	GET_PARTNER_CHECKIN_TODAY_BOOKINGS(state, data) {
		state.partner_checkin_today_bookings = data.data
	},
	GET_PARTNER_CHECOUT_TODAY_BOOKINGS(state, data) {
		state.partner_checkout_today_bookings = data.data
	},
	GET_INVENTORY_SCHEDULE(state, data) {
		state.inventory_schedule = data.data[0]
	},
	GET_FACILITY_SCHEDULE(state, data) {
		state.facility_schedule = data.data[0]
	},
	PAYMENT_GATEWAYS(state, data) {
		state.payment_gateways = data.data
	},
	BOOKING_VOLUME_REPORT(state, data) {
		state.volume = data.data
		state.volume_gtt = data.grand_total
	},
	GET_SINGLE_FACILITY_AVAILABILITY(state, data) {
		state.single_facility = data.data;
	},
	PAYMENT_FAILURE(state, data) {
		state.payment_failure = data.data;
	},
	GET_INSPECTION_BOOKINGS_TODAY(state, data) {
		state.inspection_bookings = data.data;
	},
	GET_INSPECTED_ALERTED_BOOKINGS(state, data) {
		state.inspection_alerted_bookings = data.data;
	},
	GET_MORE_INSPECTED_ALERTED_BOOKINGS(state, data) {
		var bookings = data.data
		for (var i = 0; i < bookings.length; i++) {
			state.inspection_alerted_bookings.push(bookings[i])
		}
	},


	GET_INSPECTED_UNTICKETED_ALERTED_BOOKINGS(state, data) {
		state.inspection_unticketed_alerted_bookings = data.data;
	},
	GET_MORE_INSPECTED_UNTICKETED_ALERTED_BOOKINGS(state, data) {
		var bookings = data.data
		for (var i = 0; i < bookings.length; i++) {
			state.inspection_unticketed_alerted_bookings.push(bookings[i])
		}
	},
	GET_INSPECTION_BOOKING(state, data) {
		state.inspection_booking = data.data[0];
	},
	GET_BOOKINGS_RESIDENCY_PROOF(state, data) {
		state.all_residency_proof = data.data;
	},
	GET_MORE_RESIDENCY_PROOFS(state, data) {
		var booking_proofs = data.data
		for (var i = 0; i < booking_proofs.length; i++) {
			state.all_residency_proof.push(booking_proofs[i])
		}
	},
	GET_ALL_BOOKINGS_BAN(state, data) {
		state.all_bookings_ban = data.data;
		
	},
	GET_MORE_BOOKINGS_BAN(state, data) {
		var bookings_ban = data.data
		for (var i = 0; i < bookings_ban.length; i++) {
			state.all_bookings_ban.push(bookings_ban[i])
		}
	},
	GET_BOOKING_BAN(state, data) {
		state.booking_ban = data.data;
	},
	// finance statement for users\
	GET_PUSER_BOOKINGS(state, data) {
		state.puser_bookings = data.data;
	},
	GET_FINANCE_STATEMENT(state, data) {
		state.finanace_statement = data.data;
	},
	GET_ALL_BOOKING_USERS(state, data) {
		state.booking_users = data.data;
	},
	GET_BANK_SLIP(state, data) {
		state.bank_slip = data.data;
	},
	GET_BANK_SLIP_DATA(state, data) {
		state.bankslip_data = data.data;
	},
	GET_BOOKING_PAYMENT_FAILURE(state, data) {
		state.booking_payment_failure = data.data;
	},
	GET_MORE_BOOKING_PAYMENT_FAILURE(state, data) {
		var payment_fails = data.data
			for (var i = 0; i < payment_fails.length; i++) {
				state.booking_payment_failure.push(payment_fails[i])
			}
	},
	GET_BOOKING_PAYMENTS(state, data) {
		state.all_booking_payment = data.data;
	},
	
	GET_MORE_BOOKING_PAYMENTS(state, data) {
		var booking_payments = data.data
		for (var i = 0; i < booking_payments.length; i++) {
			state.all_booking_payment.push(booking_payments[i])
		}

	},
	GET_SEARCH_BOOKING_PAYMENTS(state, data) {
		var booking_payments = data.data
		state.all_booking_payment = []
		for (var i = 0; i < booking_payments.length; i++) {
			state.all_booking_payment.push(booking_payments[i])
		}

	},
	GET_MORE_BANK_SLIP_DATA(state, data) {
		var bank_slips = data.data
		
			for (var i = 0; i < bank_slips.length; i++) {
				state.bankslip_data.push(bank_slips[i])
			}

	},
	CURRENT_PAYMENTS_SEARCH(state, data) {
		state.current_payment_search = data;
	},
	
}
